import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <p>
          学院地址：广州市海珠区昌岗东路257号/番禺区广州大学城外环西路168号
          <br />
          版权所有：广州美术学院&nbsp;
          <a
            style={{ color: "rgba(0, 0, 0, 0.5)" }}
            rel="noopener noreferrer"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
          >
            粤ICP备09183285号-2
          </a>
        </p>
      </div>
    );
  }
}

export default Footer;
